<template>
    <div class="info_box">
        <div class="flex info_head_box">
            <div
                class="info_head"
                :class="item.showCount > 0 ? 'active_info' : ''"
				v-show="item.payStatus"
                v-for="(item,index) in statusList"
                :key="index"
            >
                <h4>{{item.title}}</h4>
                <div class="head_content" :class="index === 0 ? 'first_box' : ''">
					<PaymentRecordImageHeader :item-detail="item"/>

                    <template v-if="item.id === 1">
                        <PayImgInfo :itemDetail="item" :info="detailInfo"></PayImgInfo>
                    </template>
                    <template v-else>
                        <div class="pay_info_box">
                            <PayImgInfo v-for="(listItem,index) in detailInfo[item.confirmedList]"
                                        :itemDetail="item"
                                        :info="detailInfo"
                                        :listItem="listItem"
                                        :confirmed="true"
                                        :key="index"></PayImgInfo>
                            <PayImgInfo v-for="(listItem,index) in detailInfo[item.requestedList]"
                                        :itemDetail="item"
                                        :info="detailInfo"
                                        :listItem="listItem"
                                        :confirmed="false"
                                        :key="index"></PayImgInfo>
                        </div>
                    </template>
                </div>
                <div v-if="item.id === 1" class="info_bottom">
                    <div class="info_item">
						<div class="item_content" v-if="detailInfo.invoiceNumber !== detailInfo.assignmentInvoiceNumber">
							<label>{{$t('common.bundleNumber')}}:</label>
							<span>{{detailInfo.assignmentInvoiceNumber}}</span>
						</div>
                        <div class="item_content">
                            <label>{{$t('common.assignmentDate')}}:</label>
                            <span>{{detailInfo.assignmentDate}}</span>
                        </div>
                        <div class="item_content">
                            <label>{{$t('seller.payments.details.info.purchasePrice')}}</label>
                            <span>{{detailInfo.settlementPrice}}</span>
                        </div>
                        <div class="item_content">
                            <label>{{$t("common.assignmentCategory")}}:</label>
                            <span>{{detailInfo.postTrade}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {sellerPaymentsApi} from "@/common/api/sellerPaymentsApi";
import PayImgInfo from "./PayImgInfo";
import {formatAsLocalizedDate, formatAsLocalizedEnum, formatAsMoneyAmount} from "@/common/format";
import {enumDef} from "@/common/enumDefs";
import {paymentProgress} from "@/common/utils/paymentProgress";
import PaymentRecordImageHeader from "@/components/templates/common/payments/PaymentRecordImageHeader";

export default {
    components: {
		PaymentRecordImageHeader,
        PayImgInfo
    },
    props: {
        params: Object
    },
    data() {
        return {
            statusList: [
                {
                    title: this.$t("seller.payments.details.auctionFee.title"),
                    showCount: 0,
                    id: 1,
                    statusKey: "auctionFeePaymentStatus",
                    imgUrl1: "seller",
                    imgUrl2: "tnp",
					payStatus: null,
					paidText: ""
                },
                {
                    title: this.$t("seller.payments.details.investorToSeller.title"),
                    showCount: 0,
                    id: 2,
                    statusKey: "buyerToSellerPaymentStatus",
                    expected: "buyerToSellerAmountExpected",
                    alreadyPaid: "buyerToSellerAmountAlreadyPaid",
                    confirmedList: "buyerToSellerConfirmedPayments",
                    imgUrl1: "buyer",
                    imgUrl2: "seller",
					payStatus: null,
					paidText: ""
                },
                {
                    title: this.$t("seller.payments.details.debtorToSeller.title"),
                    showCount: 0,
                    id: 3,
					dueDateKey: "dueDate",
                    statusKey: "debtorToSellerPaymentStatus",
                    expected: "debtorAmountExpected",
                    alreadyPaid: "debtorAmountAlreadyPaid",
                    confirmedList: "fromDebtorConfirmedPayments",
                    imgUrl1: "debtor",
                    imgUrl2: "seller_tnp",
					payStatus: null,
					paidText: ""
                },
                {
                    title: this.$t("seller.payments.details.sellerToInvestor.title"),
                    showCount: 0,
                    id: 4,
					dueDateKey: "dueDate",
                    statusKey: "sellerToBuyerPaymentStatus",
                    expected: "sellerAmountExpected",
                    alreadyPaid: "sellerAmountAlreadyPaid",
                    requested: "sellerAmountRequested",
                    confirmedList: "toBuyerConfirmedPayments",
                    requestedList: "sellerRequestedBankTransfers",
                    imgUrl1: "seller_tnp",
                    imgUrl2: "buyer",
					payStatus: null,
					paidText: ""
                }
            ],
            detailInfo: {}
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        getDetail() {
            sellerPaymentsApi.inspection.getDetails(this.params.data.assignmentId, this.params.data.receivableId)
                .then(res => {
                    this.detailInfo = {
                        ...res,
                        dueDate: formatAsLocalizedDate(res.dueDate),
                        invoiceDate: formatAsLocalizedDate(res.invoiceDate),
                        assignmentDate: formatAsLocalizedDate(res.assignmentDate),
                        postTrade: formatAsLocalizedEnum(enumDef.postTradeType, res.postTrade),
                        amount: formatAsMoneyAmount(res.amount, { currency: res.currency }),
                        settlementPrice: formatAsMoneyAmount(res.settlementPrice, { currency: res.currency }),
                        auctionFeePaymentDate: formatAsLocalizedDate(res.auctionFeePaymentDate),
                        auctionFeeAmount: formatAsMoneyAmount(res.auctionFeeAmount, { currency: res.currency }),
                    };

                    this.setupPayStatus(res);
                })
                .catch(this.toast);
        },
        setupPayStatus(info) {
            this.statusList.forEach(item => {
            	let paymentStatus = item.id === 1
					? paymentProgress.getStatusForFee(info[item.statusKey])
					: paymentProgress.getStatusForSettlement(info[item.dueDateKey], info[item.statusKey], info[item.alreadyPaid], info[item.requested], info[item.expected]);

            	if (paymentStatus) {
		            item.payStatus = paymentStatus.code;
		            item.paidText = paymentStatus.name;
	            }
            });

        }
    }
};
</script>

<style lang="scss" scoped>
@import "./payments.scss";
</style>